import { validation } from '@ynap/form-utils'

export default function validate(values, props) {
    const { day, month, year } = values.dateOfBirthGroup || {}
    const formattedDate = day || month || year ? `${day}/${month}/${year ? year : '1900'}` : undefined
    const { messages, enableAgeConsent, locale } = props
    const errors: Record<string, string> = {}

    const requiredFields = ['firstName', 'lastName', 'personTitle']
    requiredFields.forEach((fieldName) => {
        if (validation.isEmpty(values[fieldName])) {
            errors[fieldName] =  messages.errors.required({ field: messages.personalInfoForm[fieldName]() })
        }
    })

    if (formattedDate) {
        if (!validation.isValidDob(formattedDate)) {
            errors.dateOfBirthGroup = messages.errors?.invalidDob({ country: locale?.country})
        } else if (!validation.isValidDob(formattedDate, 1900, enableAgeConsent ? 14 : 0)) {
            errors.dateOfBirthGroup = messages.errors.underAge()
        }
    }

    return errors
}
